type PersonaIcons = {
    [key: string]: string
  }
  
export const personaIcons: PersonaIcons = {
    games: require("../../assets/personas/games.png"),
    sports: require("../../assets/personas/sports.png"),
    fitness: require("../../assets/personas/fitness.png"),
    music: require("../../assets/personas/music.png"),
    entertainment: require("../../assets/personas/movie.png"),
    hobbies: require("../../assets/personas/toy.png")
};